<script setup lang="ts">
import { onMounted, computed } from 'vue'
import vi_VN from 'ant-design-vue/es/locale/vi_VN'
import dayjs from 'dayjs'
import 'dayjs/locale/vi'
import { storeToRefs } from 'pinia'

import { LIST_THEMES } from '@/utils/constants.ts'
import { useLsStorage } from '@/composables/storage.ts'
import { useAppStore } from '@/stores/app.ts'
import { useGlobalListStore } from '@/stores/global-list.ts'

dayjs.locale('en')

const ls = useLsStorage()
const appStore = useAppStore()
const { currentAppName } = storeToRefs(appStore)
const globalListStore = useGlobalListStore()
const { globalListItems } = storeToRefs(globalListStore)
// Clear all global list items
globalListItems.value = {}

currentAppName.value = import.meta.env.VITE_APP_NAME
const setTheme = () => {
  const appStore = useAppStore()
  const keyThemeDefault = ls.getItem('_THEME_DEFAULT')

  const themeDefault = LIST_THEMES.find((l: { key: number }) => l.key === Number(keyThemeDefault))
  appStore.setTheme(themeDefault ? themeDefault.class : LIST_THEMES[0].class)
}

const theme = {
  token: {
    colorPrimary: '#05428C',
    borderRadius: 2,
    fontFamily: "'Quicksand', sans-serif",
    fontFeatureSettings: 'tnum',
  },
}

const isRefreshingToken = computed(() => {
  const auth = useAuth()
  return auth.isRefreshingToken
})

onMounted(() => {
  setTheme()
})
</script>

<template>
  <div id="app-inner">
    <div id="loading-app" class="flex h-screen flex-col items-center justify-center">
      <a-spin tip="Đang tải ..." />
    </div>
    <a-config-provider :locale="vi_VN" :theme="theme">
      <router-view>
        <template #default="{ Component }">
          <component :is="Component" />
        </template>
      </router-view>
    </a-config-provider>
    <div v-if="isRefreshingToken" class="global-loading-overlay">
      <a-spin size="large" tip="Đang làm mới phiên đăng nhập..." />
    </div>
  </div>
</template>

<style scoped>
.global-loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(255, 255, 255, 0.6);
  backdrop-filter: blur(2px);
  z-index: 9999;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
